import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { FiltreAccueilPeriode } from '../../../FiltreAccueilPeriode';
import { RetournerStatistiquesFacturesTransmisesResultat } from '../../../RetournerStatistiquesFacturesTransmisesResultat';
import { EFactVenteService } from '../../../val-efact-vente.service';
import { CarteDashboardComponent } from '../../carte-dashboard/carte-dashboard.component';

// Carte de statistiques des factures transmises
@Component({
	selector: 'val-carte-factures-transmises',
	imports: [
		TranslocoModule,
		TranslocoCurrencyPipe,
		CarteDashboardComponent
	],
	templateUrl: './carte-factures-transmises.component.html',
	styleUrl: './carte-factures-transmises.component.scss'
})
export class CarteFacturesTransmisesComponent implements OnInit, OnChanges {

	constructor(private eFactVenteService: EFactVenteService) {
		this.filtrePeriode = FiltreAccueilPeriode.TrenteJours;
		this.chargementEnCours = false;
		this.estEnErreur = false;
		this.donnees = null;
	}

	// Période sélectionnée dans le filtre temporel
	@Input()
	public filtrePeriode: FiltreAccueilPeriode;

	// Indique si le chargement des données est en cours
	public chargementEnCours: boolean;

	// Indique si le dernier chargement s'est soldé par une erreur
	public estEnErreur: boolean;

	// Données de la carte
	public donnees: RetournerStatistiquesFacturesTransmisesResultat | null;

	public async ngOnInit(): Promise<void> {
		await this.chargerDonnees();
	}

	public async ngOnChanges(changes: SimpleChanges): Promise<void> {
		if (changes['filtrePeriode'] && !changes['filtrePeriode'].firstChange)
			await this.chargerDonnees();
	}

	public get pourcentageVolumeARegulariser(): number {
		if (!this.donnees || this.donnees.montantTtcVolumeTotal === 0) return 0;
		return Math.round(this.donnees.montantTtcVolumeARegulariser / this.donnees.montantTtcVolumeTotal * 100);
	}

	private async chargerDonnees(): Promise<void> {
		this.chargementEnCours = true;
		this.estEnErreur = false;
		this.donnees = null;

		try {
			const resultat = await this.eFactVenteService.RetournerStatistiquesFacturesTransmises(this.filtrePeriode);
			if (resultat.status === 'success' && resultat.resultat)
				this.donnees = resultat.resultat;
			else
				this.estEnErreur = true;
		} catch {
			this.estEnErreur = true;
		} finally {
			this.chargementEnCours = false;
		}
	}
}
